import styled from 'styled-components';
import { FiArrowUpRight, FiTool } from 'react-icons/fi';

export default function ServiceAdCard({ ad }) {
  return (
    <Card $tone={ad.tone} aria-label={`Publicidad demo de ${ad.name}`}>
      <Top><Demo>PUBLICIDAD · DEMO</Demo><FiTool /></Top>
      <Category>{ad.category}</Category>
      <h3>{ad.name}</h3>
      <p>{ad.copy}</p>
      <Footer><span>{ad.location}</span><b>Conocer servicio <FiArrowUpRight /></b></Footer>
    </Card>
  );
}

const Card=styled.article`min-height:310px;padding:27px;border-radius:22px;background:${({$tone})=>$tone};color:#fff;display:flex;flex-direction:column;box-shadow:0 20px 48px rgba(34,58,63,.13);h3{margin:10px 0 13px;font-size:clamp(27px,3vw,38px);line-height:.96;letter-spacing:-.045em;}p{margin:0;color:rgba(255,255,255,.73);font-size:.94rem;line-height:1.6;}`;
const Top=styled.div`display:flex;align-items:center;justify-content:space-between;>svg{font-size:22px;color:#efb39a;}`;
const Demo=styled.span`padding:6px 9px;border:1px solid rgba(255,255,255,.28);border-radius:999px;font-size:12px;font-weight:850;letter-spacing:.15em;`;
const Category=styled.span`margin-top:42px;color:#efb39a;font-size:12px;font-weight:850;letter-spacing:.16em;text-transform:uppercase;`;
const Footer=styled.footer`display:flex;justify-content:space-between;align-items:end;gap:15px;margin-top:auto;padding-top:24px;border-top:1px solid rgba(255,255,255,.17);span{font-size:12px;color:rgba(255,255,255,.65);}b{display:flex;align-items:center;gap:7px;font-size:12px;}`;
